import './table-columns.scss';

import { type ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import { LEASING_STATUSES } from '@/constants';
import { formatPrice } from '@/services/formatter';
import { getUserFullName, getUserInitials } from '@/services/helpers/strings';

import type { TLeasingOrder } from '../../../types';

type TCellInnerProps = {
  title: string;
  content: string;
};

const CellInner: React.FC<TCellInnerProps> = ({ title, content }) => {
  return (
    <>
      <h2 className="individual-leasing-table-column__cell-title">{title}</h2>
      <p className="individual-leasing-table-column__cell-content">{content}</p>
    </>
  );
};

const tableColumns: ColumnsType<TLeasingOrder> = [
  {
    title: 'ИИН / БИН',
    dataIndex: 'iin',
    key: 'iin',
    render: (_, record) => record.iin || record.client?.clientIin || '-'
  },
  {
    title: 'ФИО',
    dataIndex: 'client',
    key: 'client',
    render: (_, record) => getUserFullName(record.client) || '-'
  },
  {
    title: 'Сумма займа',
    dataIndex: 'loanAmount',
    key: 'loanAmount',
    render: (_, record) => {
      return (
        <div className="individual-leasing-table-column__cell">
          {record.totalAmount
            ? formatPrice(record.totalAmount || 0) + ' ₸'
            : '-'}
        </div>
      );
    }
  },
  {
    title: 'ПВ',
    dataIndex: 'initialPayment',
    key: 'initialPayment',
    render: (_, record) => {
      return (
        <div className="individual-leasing-table-column__cell">
          {record.initialPayment
            ? formatPrice(record.initialPayment || 0) + ' ₸'
            : '-'}
        </div>
      );
    }
  },
  {
    title: 'Создано',
    dataIndex: 'createDate',
    key: 'createDate',
    render: (_, record) => {
      return (
        <CellInner
          title={dayjs(record.createDate).format('DD.MM.YYYY, HH:mm')}
          content={getUserInitials(record.user, { hide: { middleName: true } })}
        />
      );
    }
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: (_, record) => {
      const statusColors =
        LEASING_STATUSES[record.status.code as keyof typeof LEASING_STATUSES];

      return (
        <div
          className="individual-leasing-table-column__status"
          style={{
            color: statusColors?.color || '#A0AEC0',
            backgroundColor: statusColors?.bgColor || '#F1F2F4'
          }}
        >
          {record.status.name}
        </div>
      );
    }
  }
];

export default tableColumns;
